@tailwind base;
@tailwind components;
@tailwind utilities;

/* Фиксированная шапка не должна перекрывать якорные секции */
section[id],
div[id][class*="scroll-mt"] {
  scroll-margin-top: 5rem;
}

/* Фон страницы под тёмной темой: секции перекрывают его, но при
   медленной загрузке не должно быть белой вспышки */
html {
  background-color: #fafaf8;
}

html.dark {
  background-color: #0a0a0a;
  color-scheme: dark;
}

/* Плавный переход по якорям отключён для пользователей,
   которые предпочитают уменьшенную анимацию */
@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
}
